import {
  InvalidSessionException,
  UserIsInvalidException,
} from '@/domain/user/exceptions';
import { UnknowErrorException } from '@/domain/common/exceptions';

export const verifySessionExecute = async (verifyUserSession) => {
  const {
    data: dataUser,
    status: statusSession,
    responseCode,
  } = await verifyUserSession();
  if (statusSession === 200 && responseCode === '00') {
    return dataUser;
  } else if (responseCode === '03') {
    throw new InvalidSessionException({
      errorCode: responseCode,
      message: 'Sessión finalizada',
    });
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message: 'Error interno',
    });
  }
};

export const dateUserExecute = async (userCode, getDateUser) => {
  const {
    data: dataUser,
    status: statusSession,
    responseCode,
  } = await getDateUser(userCode);
  if (statusSession === 200 && responseCode === '00') {
    return dataUser;
  } else if (responseCode === '02') {
    throw new UserIsInvalidException({
      errorCode: responseCode,
      message: 'User no válido',
    });
  } else {
    throw new UnknowErrorException({
      errorCode: responseCode,
      message: 'Error interno',
    });
  }
};
